export default __webpack_public_path__ + "4e0df4648cf086cd631177605b838d9b.png";